// extracted by mini-css-extract-plugin
export default {"container":"SupportedCreditCardsMessage__container___W3v3n","text":"SupportedCreditCardsMessage__text___Nl4R6","image":"SupportedCreditCardsMessage__image___M6BNA"};